import Vue from "vue";
import Vuetify from "vuetify";
import theme from "../theme";
import fr from "vuetify/es5/locale/fr";
import en from "vuetify/es5/locale/en";
import "vuetify/dist/vuetify.min.css";

import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify);

const opts = {
    theme: {
        themes: theme,
    },
    lang: {
        locales: {
            fr,
            en,
        },
    },
    icons: {
        iconfont: "mdi",
    },
};

const vuetify = new Vuetify(opts);

export default vuetify;
